import {createTheme} from "@mui/material/styles";

const theme = createTheme({
    palette:{
        primary:{
            main: "#0E8F4B"
        },
        text:{
            primary: "#0D1729"
        }
    },
});
export default theme;